import React from "react";
import {Component} from "react";
import {Modal} from "antd";
import { injectIntl } from "react-intl";

export class RestoreModal extends Component {

    render() {
        const {
            loading,
            showRestoreModal,
            handleHiddenRestoreModal,
            intl
        } = this.props;

        return (
            <React.Fragment>
                <Modal
                    visible={showRestoreModal}
                    onCancel={handleHiddenRestoreModal}
                    footer={null}
                    scrollableBody={true}
                    style={{ 
                        top: 20,
                        maxWidth: "20%",
                    }}
                    destroyOnClose
                    confirmLoading={loading}
                    centered
                    closeIcon={null}
                >
                    <p
                        style= {{
                            textAlign: "center"
                        }}
                    >
                        {intl.formatMessage({id: "trash-assets-restore"})}
                    </p>
                </Modal>
            </React.Fragment>
        )
    }
}

export default injectIntl(RestoreModal);